import { App as AntApp, Tooltip } from "antd";
import { useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import AntIcon from "../icons/AntIcon";
import styles from "./CopyToClipboardView.module.scss";

interface Props {
  content?: string;
  wrapper?: React.ReactElement | string;
  style?: React.CSSProperties;
}

const CopyToClipboardView = ({ content, wrapper, style }: Props) => {
  const { t } = useTranslation();
  const { message } = AntApp.useApp();

  const [isHovered, setIsHovered] = useState(false);

  return content ? (
    <span
      style={{ display: "inline-block", ...style }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {wrapper ?? content}

      <CopyToClipboard text={content} onCopy={() => message.info(t("common.clipboardCopied"))}>
        <Tooltip title={t("common.copy")} mouseEnterDelay={0.5}>
          <span style={{ marginLeft: 4 }}>
            <AntIcon
              type="copy"
              style={isHovered ? { visibility: "visible" } : undefined}
              className={styles.copyToClipboardViewAnticon}
            />
          </span>
        </Tooltip>
      </CopyToClipboard>
    </span>
  ) : null;
};

export default CopyToClipboardView;
